import React from 'react';
import { motion } from 'framer-motion';
import { BVLogo } from './BVLogo';
export function LoadingScreen() {
  return <motion.div initial={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeInOut'
  }} className="fixed inset-0 z-[100] bg-[#1d1d1f] flex items-center justify-center" data-id="element-166">
      <div className="flex flex-col items-center" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-10" data-id="element-168">
          <BVLogo size={120} darkBackground data-id="element-169" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center gap-6" data-id="element-170">
          <div className="w-48 h-[1px] bg-white/10 rounded-full overflow-hidden" data-id="element-171">
            <motion.div initial={{
            width: 0
          }} animate={{
            width: '100%'
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut'
          }} className="h-full bg-[#c9a961]" data-id="element-172" />
          </div>
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} className="text-[#86868b] text-[11px] uppercase tracking-[0.3em] font-medium" data-id="element-173">
            We Define Hospitality
          </motion.p>
        </motion.div>
      </div>
    </motion.div>;
}